import React from "react";
import {Button, Result} from "antd";
import {useTranslation} from "react-i18next";

// Shown instead of the verification steps when the initial data didn't load
// (see lib/load.js). Shared by every layout.
export default function VerificationLoadError({onRetry}) {
    const {t} = useTranslation();

    return (
        <Result
            status="warning"
            title={t("accountVerification.loadError.title", "We couldn't load your verification details")}
            subTitle={t("accountVerification.loadError.description", "Please check your connection and try again.")}
            extra={
                <Button type="primary" onClick={onRetry}>
                    {t("common.retry", "Retry")}
                </Button>
            }
        />
    );
}
